module.exports = __webpack_public_path__ + "img/icon01.38015af0.png";